export const 
    HIDE_MODAL = 'HIDE_MODAL',
    SHOW_MODAL='SHOW_MODAL';


// WEBPACK FOOTER //
// ./src/types/Modal.js